import gql from 'graphql-tag';

import { contentAppearancePublishedFragment } from '@confluence/content-appearance/entry-points/fragments';

import { byLineUserFragment } from './fragments/byLineUserFragment.fragment';

export const ContentAndHeaderQuery = gql`
	query ContentAndHeaderQuery(
		$contentId: ID!
		$spaceKey: String = null
		$versionOverride: Int = null
		$embeddedContentRender: String = null
		$limit: Int = 4
		$useNewContentTopper: Boolean = false
	) @SLA {
		content(
			id: $contentId
			version: $versionOverride
			embeddedContentRender: $embeddedContentRender
		) {
			nodes {
				id
				type
				subType
				title
				history {
					createdBy {
						...byLineUserFragment
					}
				}
				emojiTitlePublished: properties(key: "emoji-title-published") {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				pageTitlePublished: properties(key: "page-title-property-published")
					@include(if: $useNewContentTopper) {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				properties(keys: ["cover-picture-id-published", "editor"]) {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				space {
					id
					key
					name
				}
				version {
					confRev
					message
					by {
						...byLineUserFragment
					}
					friendlyWhen
					number
					contentTypeModified
				}
				metadata {
					sourceTemplateEntityId
					lastModifiedDate
					frontend {
						fabricEditorSupported
						coverPictureWidth @include(if: $useNewContentTopper)
					}
				}
				body {
					dynamic {
						representation
						value
						webresource {
							superbatch {
								tags {
									js
									css
								}
							}
							tags {
								js
								css
							}
						}
					}
				}
				...contentAppearancePublishedFragment
			}
		}
		contentContributors(id: $contentId, limit: $limit) {
			count
			isCurrentUserContributor
			nodes {
				...byLineUserFragment
			}
		}
		space(key: $spaceKey) {
			id
			theme {
				name
				themeKey
			}
			lookAndFeel {
				headings {
					key
					value
				}
				content {
					header {
						background
						backgroundAttachment
						backgroundBlendMode
						backgroundClip
						backgroundColor
						backgroundImage
						backgroundOrigin
						backgroundPosition
						backgroundRepeat
						backgroundSize
						borderRadius
						padding
					}
					screen {
						background
						backgroundColor
						backgroundImage
						backgroundPosition
						backgroundSize
						backgroundRepeat
						backgroundOrigin
						backgroundClip
						backgroundAttachment
						backgroundBlendMode
						layer {
							background
							backgroundColor
							backgroundImage
							backgroundPosition
							backgroundSize
							backgroundRepeat
							backgroundOrigin
							backgroundClip
							backgroundAttachment
							backgroundBlendMode
							width
							height
						}
						gutterTop
						gutterRight
						gutterBottom
						gutterLeft
					}
					container {
						background
						backgroundColor
						backgroundImage
						backgroundPosition
						backgroundSize
						backgroundRepeat
						backgroundOrigin
						backgroundClip
						backgroundAttachment
						backgroundBlendMode
						padding
						borderRadius
					}
				}
			}
			settings {
				routeOverrideEnabled
			}
		}
	}

	${byLineUserFragment}
	${contentAppearancePublishedFragment}
`;
